import { handleErrResponse, transformErrorsForForm } from '../../common/api'

export const isLimitReached = (err): boolean => {
  const errors = handleErrResponse(err)

  const errorsForForm = transformErrorsForForm(errors)
  // console.log(errors, errorsT)
  return errorsForForm && errorsForForm['limited']
}
